import React from 'react'
import { Button, Container, Stack, Typography } from '@airbus/components-react/components'
import { useNavigate } from 'react-router-dom'

const Unauthorized = () => {
  const navigate = useNavigate()

  const goBack = () => navigate(-1)

  return (
    <Container style={{ flex: 1 }} fixed>
      <Stack align='center'>
        <Typography variant='h1'>Unauthorized</Typography>
        <br />
        <Typography>You do not have access to the requested page.</Typography>
        <div className='flexGrow'>
          <Button variant='primary' onClick={goBack}>
            Go Back
          </Button>
        </div>
      </Stack>
    </Container>
  )
}

export default Unauthorized
